import React from "react";
import EmployeesReport from "./EmployeesReport";

export default function ContractorsReport() {
  return <EmployeesReport title="contractorsReport" permanent={false} />;
}
